import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    plasiyerCustomer: null,
    secondState: true,
    secondMsg: '',
    appAlert: {
      show: false,
      title: '',
      message: '',
      type: 'warning',
    },
  },
  mutations: {
    PLASIYER_CUSTOMER(state, value) {
      state.plasiyerCustomer = value
    },
    SECOND_STATE(state, value) {
      state.secondState = value
    },
    SECOND_MSG(state, value) {
      state.secondMsg = value
    },
    SHOW_APP_ALERT(state, { title, message, type = 'warning' }) {
      state.appAlert.title = title
      state.appAlert.message = message
      state.appAlert.type = type
      state.appAlert.show = true
    },
    HIDE_APP_ALERT(state) {
      state.appAlert.show = false
    },
  },
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
  },
})
